module.exports = __webpack_public_path__ + "img/1_029.f1257840.jpg";